// extracted by mini-css-extract-plugin
module.exports = {"viewCandidate":"NUPWDcRL","viewCandidateModal":"_26fSVpp8","scrollDiv":"_3Avb4phX","contentContainer":"_7FSBYCyq"};
    if(module.hot) {
      // 1746735836598
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  